const nav = [
  {
    group: 'Getting Started',
    items: [
      { id: 'overview',   label: 'Overview'      },
      { id: 'quickstart', label: 'Quickstart'    },
      { id: 'concepts',   label: 'Core Concepts' },
    ],
  },
  {
    group: 'Catalog Setup',
    note: 'Define what you sell and how it is priced',
    items: [
      { id: 'product',           label: 'Products'                             },
      { id: 'product-attribute', label: 'Product Attributes', indent: true },
      { id: 'meter',   label: 'Meters'                    },
      { id: 'billable-metric',   label: 'Billable Metrics',   indent: true },
      { id: 'fee',               label: 'Fees'                               },
      { id: 'pricing-dimensions',       label: 'Pricing Dimensions'        },
      { id: 'rate-card',             label: 'Rate Cards'             },
      { id: 'pricing-models',        label: 'Pricing Models',        indent: true },
      { id: 'proration',             label: 'Proration',             indent: true },
      { id: 'rate-card-time-based',  label: 'Time-Based Rate Cards', indent: true },
      { id: 'rate-card-wildcard',    label: 'Wildcard Dimensions',   indent: true },
      { id: 'rate-card-calculator',  label: 'Calculator',            indent: true },
      { id: 'plan',                  label: 'Plans'                                },
    ],
  },
  {
    group: 'Customers & Contracts',
    note: 'Apply catalog pricing to specific customers',
    items: [
      { id: 'customer',                label: 'Customers'        },
      { id: 'contract',                label: 'Contracts'        },
      { id: 'contract-fee-components', label: 'Fee Settings',        indent: true },
      { id: 'milestone-fee',           label: 'Milestone-Based Fees', indent: true },
      { id: 'contract-settings',       label: 'Limits & Renewal',     indent: true },
      { id: 'contract-create',         label: 'Build a Contract',indent: true, badge: 'interactive' },
      { id: 'grant',                   label: 'Grants'           },
    ],
  },
  {
    group: 'Operations',
    items: [
      { id: 'usage',           label: 'Usage'           },
      { id: 'billing-report',  label: 'Billing Reports' },
      { id: 'api-reference',   label: 'API Reference'   },
    ],
  },
];

export default nav;
